import { Fragment, useContext, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import ListChoice from "components/DesignComponents/ListChoice";
import TableContext from "context/table/tableContext";
import { Column, noop } from "shared";

import GoBack from "./GoBack";
import { SetContentProps } from "./types";

const ColumnsToShow = ({ setContent }: SetContentProps) => {
    const { blue700, gray300, white } = colors;

    const { columns, toggleActiveColumn, restoreActiveColumns } =
        useContext(TableContext);

    const { t } = useTranslation();

    const areDefaultColumns = columns.every(
        column => Boolean(column.isDefaultActive) === column.isActive
    );

    const [isResetDisabled, setIsResetDisabled] = useState(areDefaultColumns);

    useEffect(() => {
        setIsResetDisabled(areDefaultColumns);
    }, [columns, areDefaultColumns]);

    return (
        <Fragment>
            <GoBack setContent={setContent} />

            {columns.map(
                ({
                    name,
                    isActive,
                    isDisabled,
                    isNameNotTranslatable
                }: Column) => {
                    return (
                        <ListChoice
                            key={`${name}-${isActive}`}
                            title={
                                isNameNotTranslatable
                                    ? name
                                    : t(`Table##${name}`)
                            }
                            selected={isActive}
                            isCheckbox
                            disabled={isDisabled}
                            onClick={() => toggleActiveColumn(name)}
                        />
                    );
                }
            )}

            <ListChoice
                title={t("Button##reset to default")}
                onClick={isResetDisabled ? noop : restoreActiveColumns}
                disabled={isResetDisabled}
                css={css({
                    position: "sticky",
                    bottom: "0",
                    background: white,
                    zIndex: "1",
                    color: blue700,
                    borderTop: `1px solid ${gray300}`,
                    paddingTop: "13px",

                    "&:hover": {
                        "&.Mui-disabled": {
                            background: white
                        }
                    },

                    "&.Mui-disabled": {
                        pointerEvents: "auto"
                    }
                })}
            />
        </Fragment>
    );
};

export default ColumnsToShow;
